import { render, staticRenderFns } from "./CustomerFormEmergencyContacts.vue?vue&type=template&id=fc95ceca"
import script from "./CustomerFormEmergencyContacts.vue?vue&type=script&lang=js"
export * from "./CustomerFormEmergencyContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports